// react and js

// mui

// components

// hooks

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
// Default state storage values
export const stateStorageInit = {
  // Backbone
  authenticated: false,
  userInformation: "",
  hasApplicationSubscriptions: null,

  // Layout update flag for sidebar
  layoutUpdateFeatures: true,
  //
  layoutUpdateIntervalFeatures: 7500,

  // Page: account_settings
  widgetUpdateAccountSettingChangePassword: true,
  widgetUpdateAccountSettingPersonalInformation: true,
  widgetUpdateAccountSettingPromoterInformation: true,
  widgetUpdateAccountSettingDistributorInformation: true,
  widgetUpdateAccountSettingAdministratorInformation: true,
  //
  widgetUpdateIntervalAccountSetting: 5000,

  // Page: subscriptions
  widgetUpdateSubscriptionsSubscriptions: true,
  //
  widgetUpdateIntervalSubscriptionsSubscriptions: 5000,

  // Page: downloads
  widgetUpdateDownloadsApplications: true,
  widgetUpdateDownloadsMt5TickData: true,
  //
  widgetUpdateIntervalDownloadsApplications: 5000,
  widgetUpdateIntervalDownloadsMt5TickData: 5000,

  // Page: accounting
  widgetUpdateBillingAccountingNote: true,
  widgetUpdateBillingInvoicesAndReceipes: true,
  //
  widgetUpdateIntervalBillingAccountingNote: 5000,
  widgetUpdateIntervalBillingInvoicesAndReceipes: 5000,

  // Page: distributor_portal
  widgetUpdateDistributorPortalDistributionCustomers: true,
  widgetUpdateDistributorPortalManageDistributionCustomer: true,
  widgetUpdateDistributorPortalManageDistributionCustomerInvoices: true,
  widgetUpdateDistributorPortalTickDataDistributionCustomers: true,
  widgetUpdateDistributorPortalManageTickDataDistributionCustomer: true,
  widgetUpdateDistributorPortalManageTickDataDistributionCustomerInvoices: true,
  widgetUpdateDistributorPortalContingents: true,
  widgetUpdateDistributorPortalRevenueCommission: true,
  widgetUpdateDistributorPortalAvailablePlans: true,
  widgetUpdateDistributorPortalAvailableTickDataPlans: true,
  widgetUpdateDistributorPortalApplicationLimitations: true,
  //
  widgetUpdateIntervalDistributorPortalDistributionCustomers: 10000,
  widgetUpdateIntervalDistributorPortalManageDistributionCustomer: 10000,
  widgetUpdateIntervalDistributorPortalTickDataDistributionCustomers: 10000,
  widgetUpdateIntervalDistributorPortalManageTickDataDistributionCustomer: 10000,
  widgetUpdateIntervalDistributorPortalContingents: 10000,
  widgetUpdateIntervalDistributorPortalRevenueCommission: 10000,
  widgetUpdateIntervalDistributorPortalAvailablePlans: 10000,
  widgetUpdateIntervalDistributorPortalAvailableTickDataPlans: 10000,
  widgetUpdateIntervalDistributorPortalApplicationLimitations: 10000,
  //
  widgetPerformBackScrollDistributorPortalManageDistributionCustomer: false,
  widgetPerformBackScrollDistributorPortalManageTickDataDistributionCustomer: false,

  // Page: evaluation_portal
  widgetUpdateEvaluationPortalEvaluationPortal: true,
  //
  widgetUpdateIntervalEvaluationPortalEvaluationPortal: 5000,

  // Page: application_settings
  widgetUpdateApplicationSettingsApplicationSettingsMine: true,
  widgetUpdateApplicationSettingsApplicationSettingsAllUser: true,
  //
  widgetUpdateIntervalApplicationSettingsApplicationSettingsMine: 5000,
  widgetUpdateIntervalApplicationSettingsApplicationSettingsAllUser: 5000,
};
